import { render } from "./special_prize.vue?vue&type=template&id=5bd5216b&scoped=true"
import script from "./special_prize.vue?vue&type=script&lang=js"
export * from "./special_prize.vue?vue&type=script&lang=js"

import "./special_prize.vue?vue&type=style&index=0&id=5bd5216b&lang=scss&scoped=true"
import "./special_prize.vue?vue&type=style&index=1&id=5bd5216b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd5216b"]])

export default __exports__